export const DRAFTS_GROUP_LINKS = {
  BASE: "/app/drafts",
  ADD_DRAFT: "/app/drafts/create",
  VIEW_DRAFT: "/app/drafts/:draftId/view",
  EDIT_DRAFT: "/app/drafts/:draftId",
  SETTINGS: "/app/settings",
};
